var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5H14.5C15.471 6.5 16.334 6.961 16.883 7.677L21.042 13L16.882 18.323C16.6023 18.6892 16.2418 18.9859 15.8287 19.1901C15.4155 19.3942 14.9608 19.5003 14.5 19.5H6.5C5.70435 19.5 4.94129 19.1839 4.37868 18.6213C3.81607 18.0587 3.5 17.2956 3.5 16.5V9.5C3.5 8.70435 3.81607 7.94129 4.37868 7.37868C4.94129 6.81607 5.70435 6.5 6.5 6.5ZM16.078 17.73L19.773 13L16.078 8.27L16.076 8.269C15.8892 8.0293 15.6501 7.83542 15.377 7.70216C15.1039 7.56889 14.8039 7.49974 14.5 7.5H6.5C5.96957 7.5 5.46086 7.71071 5.08579 8.08579C4.71071 8.46086 4.5 8.96957 4.5 9.5V16.5C4.5 17.0304 4.71071 17.5391 5.08579 17.9142C5.46086 18.2893 5.96957 18.5 6.5 18.5H14.5C15.14 18.5 15.71 18.2 16.076 17.731L16.078 17.729V17.73Z",
    fill: "#646397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.a93f1d2af84a90897235c419bcfc6681.svg";
export { ForwardRef as ReactComponent };